import React from 'react';

import classNames from 'classnames';
import { CheckIcon, InfoIcon, TimesIcon, WarningIcon } from 'fluxo-ui/icons';

type StatusTone = 'success' | 'error' | 'warning' | 'info';

interface StatusCircleProps {
    tone: StatusTone;
    size?: 'md' | 'lg';
    className?: string;
}

const toneClasses: Record<StatusTone, string> = {
    success: 'bg-emerald-50 text-emerald-600 dark:bg-emerald-900/30 dark:text-emerald-400 ring-emerald-100 dark:ring-emerald-900/50',
    error: 'bg-red-50 text-red-600 dark:bg-red-900/30 dark:text-red-400 ring-red-100 dark:ring-red-900/50',
    warning: 'bg-amber-50 text-amber-600 dark:bg-amber-900/30 dark:text-amber-400 ring-amber-100 dark:ring-amber-900/50',
    info: 'bg-teal-50 text-teal-600 dark:bg-teal-900/30 dark:text-teal-400 ring-teal-100 dark:ring-teal-900/50',
};

const toneIcons: Record<StatusTone, React.ComponentType<{ className?: string }>> = {
    success: CheckIcon,
    error: TimesIcon,
    warning: WarningIcon,
    info: InfoIcon,
};

const StatusCircle: React.FC<StatusCircleProps> = ({ tone, size = 'lg', className }) => {
    const Icon = toneIcons[tone];

    return (
        <div
            className={classNames(
                'rounded-full flex items-center justify-center ring-4',
                toneClasses[tone],
                size === 'lg' ? 'w-14 h-14' : 'w-10 h-10',
                className,
            )}
        >
            <Icon className={size === 'lg' ? 'w-7 h-7' : 'w-5 h-5'} />
        </div>
    );
};

export default StatusCircle;
